import { getJobPriorities, JobsPriority } from "../../../utilities/types";

// Priority constants for cycling
export const PRIORITY_URGENT = "Urgent";
export const PRIORITY_REGULAR = "Regular Turn (default)";
export const PRIORITY_NO_RUSH = "No Rush (turn+1wk)";

// Helper to get cycle order - Regular Turn first, then Urgent, then others
export function getPriorityCycleOrder(): JobsPriority[] {
	const allPriorities = getJobPriorities();

	// Reorder: Regular Turn first, then Urgent, then the rest
	const regularIndex = allPriorities.indexOf(PRIORITY_REGULAR);
	const urgentIndex = allPriorities.indexOf(PRIORITY_URGENT);

	if (regularIndex === -1 || urgentIndex === -1) {
		console.warn("Could not find Urgent or Regular Turn priorities");
		return allPriorities;
	}

	// Build new array: Regular Turn, Urgent, then everything else
	const reordered: JobsPriority[] = [PRIORITY_REGULAR, PRIORITY_URGENT];
	allPriorities.forEach((priority) => {
		if (priority !== PRIORITY_REGULAR && priority !== PRIORITY_URGENT) {
			reordered.push(priority);
		}
	});

	return reordered;
}

/**
 * Returns the next priority in the 3-state cycling order.
 *
 * Cycle order: Regular Turn (Yellow) → Urgent (Red) → No Rush (Green) → Regular Turn
 *
 * When cycling from Urgent to green state, always defaults to "No Rush (turn+1wk)".
 * All other green priorities (season-specific) cycle back to Regular Turn.
 * Users can manually select season-specific priorities from the dropdown.
 *
 * @param currentPriority - The current priority value
 * @returns The next priority in the cycle
 */
export function getNextPriorityInCycle(currentPriority: JobsPriority | undefined): JobsPriority {
	if (!currentPriority) {
		return PRIORITY_REGULAR; // Default for undefined
	}

	// 3-state cycle: Regular → Urgent → No Rush → Regular
	if (currentPriority === PRIORITY_REGULAR) {
		return PRIORITY_URGENT; // Yellow → Red
	} else if (currentPriority === PRIORITY_URGENT) {
		return PRIORITY_NO_RUSH; // Red → Green (defaults to "No Rush")
	} else {
		// Any green priority (including season-specific) → Yellow
		return PRIORITY_REGULAR;
	}
}
